<template>
    <div>
        <v-card>
            <v-tabs background-color="#ececec" center-active>
                <div>
                    <v-tab>ID: {{ store.getters.getIDData }}</v-tab>
                </div>
                <!--<v-tab class="plain_title"><router-link :to="`/show-id-activity/${this.$route.params.id}`"><v-btn elevation="2" class="plain_title"><span class="plain_title">Activity</span></v-btn></router-link></v-tab>-->
                <v-tab>
                    <router-link :to="{ path: `/show-id-personal-data`, query: { id: `${route.query.id}`} }">
                        <v-btn elevation="2"><span class="plain_title">Personal Data</span></v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                    <router-link :to="{ path: `/show-id-variants`, query: { id: `${route.query.id}`} }">
                        <v-btn elevation="2"><span class="plain_title">Biomarkers</span></v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                    <router-link :to="{ path: `/show-id-analysis`, query: { id: `${route.query.id}`} }">
                        <v-btn elevation="2"><span class="plain_title">Interpretation</span></v-btn>
                    </router-link>
                </v-tab>
                <v-tab>
                    <router-link :to="{ path: `/show-id-recommendations`, query: { id: `${route.query.id}`} }">
                        <v-btn elevation="2"><span class="plain_title">Recommendations</span></v-btn>
                    </router-link>
                </v-tab>
            </v-tabs>
        </v-card>
    </div>
</template>

<script setup lang="js">
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();
</script>

